import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiHelpCircle } from "react-icons/fi";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import "./LegalPages.css";

const FAQ_ITEMS = [
  {
    q: "How do I reset my password?",
    a: "Go to Settings → Security, enter your current password, then your new password twice, and click Change Password.",
  },
  {
    q: "How do I update my profile information?",
    a: "On the Settings page, click Edit Profile under Account Details, update your name, email, or mobile number, then Save Changes.",
  },
  {
    q: "How do I mark notifications as read?",
    a: "Open the Notifications card on the Settings page and click Mark all read.",
  },
  {
    q: "Who do I contact for support?",
    a: "Check the Support phone number and email listed under the General card on the Settings page.",
  },
];

export default function FAQ() {
  const navigate = useNavigate();

  return (
    <div className="layout">
      <Sidebar />
      <div className="content">
        <Header />
        <div className="lgl-page">
          <button className="lgl-back-btn" onClick={() => navigate(-1)}>
            <FiArrowLeft size={14} /> Back
          </button>

          <div className="lgl-card">
            <div className="lgl-card-header">
              <FiHelpCircle size={16} />
              <h2>Frequently Asked Questions</h2>
            </div>

            <div className="lgl-faq-list">
              {FAQ_ITEMS.map((item, idx) => (
                <div className="lgl-faq-item" key={idx}>
                  <p className="lgl-faq-q">{item.q}</p>
                  <p className="lgl-faq-a">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}